// extracted by mini-css-extract-plugin
export var chevron = "_2x-2";
export var chevronCollapsed = "_2x-3";
export var collapsibleHeader = "_2x-1";
export var container = "_2x-0";